import React from 'react';
import { env } from '~/commons/config';
import useSearchParams from '~/commons/hooks/useSearchParams';
import ListResource from './ListResource.jsx';

const api = '/api/site/terms';
const keyMap = {
  tc: 'Terms & Conditions',
  pp: 'Privacy Policy',
  dc: 'Disclaimer',
  ua: 'Unassigned',
};

const ListTerms = () => {
  const [searchParams, setSearchParams] = useSearchParams(null);

  return (
    <ListResource
      {...{
        searchable: true,
        api,
        sort: { orgId: 1 },
        actions: {
          create: true,
        },
        filter: searchParams.get('orgId') ? { orgId: searchParams.get('orgId') } : {},
        cols: [
          { key: 'title.en', sortable: true, children: 'Title' },
          {
            key: 'orgId', sortable: true, children: 'Organization', getter: (v) => v || '',
          },
          { key: 'key', sortable: true, getter: (v) => keyMap[v] || v },
          { key: 'model', sortable: true, getter: (v) => v || 'All' },
          { key: 'version', sortable: true },
        ],
        ctrls: [
          <select
            name="orgId"
            className="custom-select"
            key="Keys"
            value={(searchParams.get('orgId') ? searchParams.get('orgId') : '')}
            onChange={(e) => {
              setSearchParams({ orgId: e.target.value });
            }}>
            <option value="">All</option>
            {(env?.showrooms || [])
              .reduce((acc, curr) => {
                if (!acc.find((f) => f.orgId === curr.orgId)) acc.push(curr);
                return acc;
              }, [])
              .map((a) => (
                <option key={JSON.stringify(a)} value={a.orgId}>
                  {`${a.orgId} - ${a.showroom || ''}`}
                </option>
              ))}
          </select>,
        ],
      }} />
  );
};

export default ListTerms;
